import { Typography } from "antd";
import { TextProps } from "antd/es/typography/Text";

import {
  ANT_DESIGN_TEXT_SIZE_ENUM,
  antDesignTextSizeMap
} from "@arbolus-technologies/utils";

interface AntDTextProps extends TextProps {
  size?: `${ANT_DESIGN_TEXT_SIZE_ENUM}`;
}

const { Text } = Typography;

export const AntDText: React.FC<AntDTextProps> = ({
  size = ANT_DESIGN_TEXT_SIZE_ENUM.MD,
  style,
  children,
  ...rest
}) => {
  return (
    <Text
      style={{
        fontSize: antDesignTextSizeMap[size].fontSize,
        lineHeight: antDesignTextSizeMap[size].lineHeight,
        ...style
      }}
      {...rest}
    >
      {children}
    </Text>
  );
};
